(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fangster-product-data"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fangster-fitment')) {
    customElements.define(
      'fangster-fitment',
      class FangsterFitment extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;

          this.dataset.ready = 'true';
          this.content = this.querySelector('[data-fg-fitment-content]');
          this.toggle = this.querySelector('[data-fg-fitment-toggle]');
          this.moreLabel = this.querySelector('[data-fg-fitment-more]');
          this.lessLabel = this.querySelector('[data-fg-fitment-less]');

          if (!this.content || !this.toggle) return;

          this.handleToggle = () => {
            this.sync(!this.hasAttribute('expanded'));
          };

          this.handleResize = () => {
            window.clearTimeout(this.resizeTimer);
            this.resizeTimer = window.setTimeout(() => this.refresh(), 120);
          };

          this.toggle.addEventListener('click', this.handleToggle);
          window.addEventListener('resize', this.handleResize, { passive: true });
          window.requestAnimationFrame(() => this.refresh());
        }

        disconnectedCallback() {
          if (this.toggle && this.handleToggle) {
            this.toggle.removeEventListener('click', this.handleToggle);
          }

          if (this.handleResize) {
            window.removeEventListener('resize', this.handleResize);
          }

          window.clearTimeout(this.resizeTimer);
        }

        getCollapsedHeight() {
          const styles = window.getComputedStyle(this);
          const rawValue = styles.getPropertyValue('--fg-fitment-collapsed-height').trim();
          const numericValue = Number.parseFloat(rawValue);

          if (!Number.isFinite(numericValue)) return 102;

          if (rawValue.endsWith('rem')) {
            const rootSize = Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize);
            return numericValue * (Number.isFinite(rootSize) ? rootSize : 10);
          }

          if (rawValue.endsWith('em')) {
            const elementSize = Number.parseFloat(styles.fontSize);
            return numericValue * (Number.isFinite(elementSize) ? elementSize : 16);
          }

          return numericValue;
        }

        refresh() {
          if (!this.content || !this.toggle) return;

          const expanded = this.hasAttribute('expanded');
          this.classList.remove('is-collapsible');

          const collapsedHeight = this.getCollapsedHeight();
          const isCollapsible = this.content.scrollHeight > collapsedHeight + 4;

          this.classList.toggle('is-collapsible', isCollapsible);
          this.toggle.hidden = !isCollapsible;
          this.sync(isCollapsible && expanded);
        }

        sync(expanded) {
          this.toggleAttribute('expanded', expanded);
          this.toggle.setAttribute('aria-expanded', String(expanded));

          if (this.moreLabel) {
            this.moreLabel.hidden = expanded;
          }

          if (this.lessLabel) {
            this.lessLabel.hidden = !expanded;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
